import React from 'react';
import { NavLink } from 'react-router-dom';
import * as Dati from '../../Dati';
import { CampoNumero, Trad, Tipo } from '../../components';
import { IFideTassiProduct } from '../../form/FideTassi';

interface IFideTassiProductProps{
    Data: IFideTassiProduct[];
    DurationTypes: Dati.TDictTipo;
    OnAddProduct: (product: IFideTassiProduct) => void;
    OnBlurRiordina: () => void;
    OnChange: (e: React.FormEvent<any> | string, valore?: any) => any;
    OnChangeDurata: (e: React.FormEvent<any>) => any;
    OnChangeSommaGarantitaA: (e: React.FormEvent<any> | string, valore?: any) => void;
    OnChangeSommaGarantitaDa: (e: React.FormEvent<any> | string, valore?: any) => void;
    OnChangeTipoDurata: (e: React.FormEvent<any> | string, valore?: any) => any;
}  

export const FideTassiProduct: React.FC<IFideTassiProductProps> = ({
    Data,
    DurationTypes,
    OnAddProduct,
    OnChange,
    OnBlurRiordina,
    OnChangeDurata,
    OnChangeSommaGarantitaA,
    OnChangeSommaGarantitaDa,
    OnChangeTipoDurata
}) => {
    const CSS: string = "form-control kt-input"
    const Banconota: string = "la la-money"
    const Percento: string = "fa fa-percentage"

    return (
        <div className="tab-pane active">
            <div className="kt-form login-form login-form--fit login-form--label-align-right login-form--group-seperator-dashed">
                <div className="col-lg-12 TextLeft">
                    <h5>
                        <NavLink
                            onClick={() => {OnAddProduct(Data[Data.length - 1]);}}
                            to="#"
                            className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg arrow"
                            title={Trad.Trad("Nuovo")}
                        >
                            <i className="fa fa-plus" />
                        </NavLink>
                        <span className="kt-padding-l-10">{Trad.Trad(Data[0].TipoRamo)} - {Trad.Trad(Data[0].TipoProdotto)}</span>
                    </h5>
                </div>
            </div>
            <div className="form-group kt-form login-form__group row">
                <div className="col-lg-3">
                    <label>{Trad.Trad("Tipo durata")}</label>
                    <Tipo Dati={DurationTypes} ID_ChiaveString={Data[0].ID_TipoDurata} Campo={`Dati.${Data[0].Index}.ID_TipoDurata`} OnAggiorna={OnChangeTipoDurata} />
                </div>

                <div className="col-lg-3">
                    <label>{Trad.Trad("Durata")}</label>
                    <div>
                        <input value={Data[0].Durata} className="form-control kt-input TextRight" name={`Dati.${Data[0].Index}.Durata`} onChange={(e) => { OnChangeDurata(e); }} />
                    </div>
                </div>
            </div>
            {Data.map(product => (
                <div className="form-group kt-form login-form__group row" key={product.Index}>
                    <div className="col-lg-3">
                        <label>{Trad.Trad("Somma garantitaDa")} &gt;</label>
                        <div className="kt-input-icon kt-input-icon--right">
                            <CampoNumero Id={`Dati.${product.Index}.SommaGarantitaDa`} Valore={product.SommaGarantitaDa} Massimo={product.SommaGarantitaA} Name={`Dati.${product.Index}.SommaGarantitaDa`} OnChange={OnChangeSommaGarantitaDa} Icona={Banconota} CSS={CSS} OnBlur={OnBlurRiordina} BarraLimiti />
                        </div>
                    </div>

                    <div className="col-lg-3">
                        <label>{Trad.Trad("Somma garantitaA")} &le;</label>
                        <div className="kt-input-icon kt-input-icon--right">
                            <CampoNumero Id={`Dati.${product.Index}.SommaGarantitaA`} Valore={product.SommaGarantitaA} Minimo={product.SommaGarantitaDa} Massimo={product.LimitePerSingoloProdotto} Name={`Dati.${product.Index}.SommaGarantitaA`} OnChange={OnChangeSommaGarantitaA} Icona={Banconota} CSS={CSS} OnBlur={OnBlurRiordina} BarraLimiti />
                        </div>
                    </div>

                    <div className="col-lg-3">
                        <label>{Trad.Trad("Premio fisso")}</label>
                        <div className="kt-input-icon kt-input-icon--right">
                            <CampoNumero Id={`Dati.${product.Index}.PremioFisso`} Valore={product.PremioFisso} Name={`Dati.${product.Index}.PremioFisso`} OnChange={OnChange} Icona={Banconota} CSS={CSS} />
                        </div>
                    </div>

                    <div className="col-lg-3">
                        <label>{Trad.Trad("Tasso min")}</label>
                        <div className="kt-input-icon kt-input-icon--right">
                            <CampoNumero Id={`Dati.${product.Index}.TassoMin`} Valore={product.TassoMin} Name={`Dati.${product.Index}.TassoMin`} OnChange={OnChange} Icona={Percento} CSS={CSS} Minimo={product.LimiteTassoMinimo} Massimo={10} Precisione={2} BarraLimiti />
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/FideTassi/FideTassiProduct.tsx